export const SIDE_CLASSES: Record<'left' | 'right', string> = {
  left: 'col-start-1 rounded-l-none border-l-0',
  right: 'col-start-[-2] col-span-1 ml-[-1px] rounded-r-none border-r-0',
}

export const CELL_COMMON_CLASSES = 'border border-moss-grey-150 rounded-[4px]'

export const CELL_CLASSES = ['rounded-t-none border-t-0', 'mt-[-1px]', 'rounded-b-none border-b-0 mt-[-1px]']

export const GRID_CLASSES: Record<number, string> = {
  3: 'max-md:grid-cols-[11.5px_216px_24px_216px_24px_216px_11.5px] md:grid-cols-[40px_minmax(auto,384px)_24px_minmax(auto,384px)_24px_minmax(auto,384px)_40px] lg:grid-cols-[20px_minmax(auto,384px)_24px_minmax(auto,384px)_24px_minmax(auto,384px)_20px] xl:grid-cols-[minmax(20px,auto)_minmax(auto,384px)_24px_minmax(auto,384px)_24px_minmax(auto,384px)_minmax(20px,auto)]',
  4: 'max-lg:grid-cols-[11.5px_216px_24px_216px_24px_216px_24px_216px_11.5px] lg:grid-cols-[20px_minmax(auto,282px)_24px_minmax(auto,282px)_24px_minmax(auto,282px)_24px_minmax(auto,282px)_20px] xl:grid-cols-[minmax(20px,auto)_minmax(auto,282px)_24px_minmax(auto,282px)_24px_minmax(auto,282px)_24px_minmax(auto,282px)_minmax(20px,auto)]',
  5: 'max-xl:grid-cols-[11.5px_216px_24px_216px_24px_216px_24px_216px_24px_216px_11.5px] xl:grid-cols-[minmax(20px,auto)_minmax(auto,220px)_24px_minmax(auto,220px)_24px_minmax(auto,220px)_24px_minmax(auto,220px)_24px_minmax(auto,220px)_minmax(20px,auto)]',
}

export const ANIMATION_SPEED: Record<number, string> = {
  3: 'max-md:animate-[slideInfinite_13s_linear_infinite]',
  4: 'max-lg:animate-[slideInfinite_16s_linear_infinite]',
  5: 'max-xl:animate-[slideInfinite_19s_linear_infinite]',
}

export const CAROUSEL_THRESHOLD: Record<number, number> = {
  3: 768,
  4: 1024,
  5: 1280,
}
